import z from "zod";

export const locationsFilterConfigurationSchema = z.object({
  locationFilterReason: z.string(),
  matches: z.array(
    z.union([
      z.object({
        type: z.literal("location"),
        match: z.string(),
        distance: z.number(),
        score: z.number(),
      }),
      z.object({
        type: z.literal("postcode"),
        match: z.string(),
        distance: z.number(),
        score: z.number(),
      }),
      z.object({
        type: z.literal("council"),
        match: z.array(
          z.object({
            key_code: z.string(),
            name: z.string(),
            checked: z.boolean(),
            confidence: z.number(),
          }),
        ),
        score: z.number(),
      }),
    ]),
  ),
});

export type LocationsAIResponse = z.infer<typeof locationsFilterConfigurationSchema>;
